import React, { memo, ReactElement } from 'react';
import { Box, Link, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AlyceTheme } from '@alycecom/ui';
import { useSelector } from 'react-redux';

import { getBranding } from '../../store/branding/branding.selectors';
import { BrandingFields } from '../../types/Branding.types';

const useStyles = makeStyles<AlyceTheme>(({ palette }) => ({
  text: {
    fontSize: 14,
    color: palette.grey.main,
  },
  link: {
    display: 'inline',
  },
}));

const AlycePrivacy = (): ReactElement => {
  const classes = useStyles();
  const customStyling = useSelector(getBranding);
  const companyName = customStyling[BrandingFields.companyName];

  return (
    <Box textAlign="center" mt={4}>
      <Typography className={classes.text}>
        By clicking and proceeding I understand and acknowledge {companyName}&apos;s&nbsp;
        <Link
          className={classes.link}
          href={customStyling[BrandingFields.privacyPolicyLink] || 'https://www.alyce.com/privacy-policy'}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          privacy policy
        </Link>
        .
      </Typography>
    </Box>
  );
};

export default memo(AlycePrivacy);
